import template from './sidemenu.html';
import controller from './sidemenu.controller';
import './sidemenu.scss';

let sidemenuComponent = {
    restrict: 'E',
    bindings: {
        user: '<'
    },
    template,
    controller
};

export default sidemenuComponent;
